import React from "react";

import SmartImage from "../../../components/SmartImage";
import { PriceBlock } from "./DetailBits";

const ProductGridCard = ({ product, onOpen }) => (
  <li className="sy-grid-card">
    <button type="button" onClick={() => onOpen(product)}>
      <span className="sy-grid-media">
        {product.imageUrls?.length ? (
          <SmartImage src={product.imageUrls[0]} alt="" aspectRatio="286 / 230" />
        ) : (
          <span className="sy-grid-placeholder" aria-hidden="true" />
        )}

        {product.inStock === false && (
          <span className="sy-badge sy-badge-stock">Out of stock</span>
        )}
      </span>

      <span className="sy-grid-body">
        <span className="sy-grid-name">{product.name}</span>

        {product.description && (
          <span className="sy-grid-desc">{product.description}</span>
        )}
      </span>

      <PriceBlock
        price={product.price}
        originalPrice={product.originalPrice}
        currency={product.currency}
      />
    </button>
  </li>
);

export default React.memo(ProductGridCard);
